<template>
  <b-modal id="project-membership-modal" size="lg" ref="projectMembershipModal" no-close-on-backdrop body-class="p-0"
    centered>
    <template slot="modal-header" class="mx-auto">
      <div>
        <h3 class="">Project Membership</h3>
        <p class="mb-0">
          How should users join your Project?
        </p>
      </div>
    </template>
    <template slot="default">
      <div class="m-4">
        <b-form-group stacked v-slot="{ ariaDescribedby }">
          <b-form-radio v-model="membership" :aria-describedby="ariaDescribedby" name="membership-radios" :value="false"
            size="lg">
            <b-img class='mr-2' src="/assets/images/open-access.png" width="50px" height="50px" alt="Open"
              title="Any CitSci user can join this project. They will not require the approval of a project manager."></b-img><span
              class="h4">Open</span>
            <b-form-group label-cols="12" label-size="md" label="">
              <span>Any CitSci user can join your project. They will not require the approval of a project manager. Great
                for public campaigns and crowd participation. </span>
            </b-form-group>
          </b-form-radio>
          <br>
          <b-form-radio v-model="membership" :aria-describedby="ariaDescribedby" name="membership-radios" :value="true"
            size="lg">
            <b-img class='mr-2' src="/assets/images/closed-access.png" width="50px" height="50px" alt="Member Based"
              title="Project managers control who can join this project through either invitations or by approving requests to join."></b-img><span
              class="h4">Member-Based</span>
            <b-form-group label-cols="12" label-size="md" label="" label-for="input-sm">
              <span>Project managers control who can join this project through either invitations or by approving
                requests to join. Use if participants need training or data needs vetting.</span>
            </b-form-group>
          </b-form-radio>
        </b-form-group>
      </div>
    </template>
    <template #modal-footer>
      <span class="mr-5">Save the Project to apply this change</span>
      <b-button size="md" variant="primary" @click="onClose()">
        Done
      </b-button>
    </template>
  </b-modal>
</template>

<script>

import { mapGetters, mapActions } from "vuex";

export default {
  components: {},
  props: {
    membershipValue: {
      type: Boolean,
      default: false,
      required: true,
    }
  },
  data() {
    return {
      // default membership value is open
      membership: false,
    }
  },
  mounted() {
  },
  created() {
    this.membership = this.membershipValue
  },
  watch: {
    membershipValue(newVal, oldVal) {
      if (newVal) {
        this.membership = newVal
      }
    }
  },
  computed: {
    ...mapGetters({}),
  },
  methods: {
    ...mapActions({}),

    onClose() {
      // emit data value to parent component
      this.$emit('membershipChange', this.membership);
      // close modal
      this.$refs.projectMembershipModal.hide()
    }
  },
}

</script>

<style scoped lang="scss"></style>
